const TEXT = {
    COMMON: {
        REMOVE: "Fjern",
    },
    HEADING: "Klikk & Hent",
    SEARCH_LABEL: "Søk etter butikk",
    SEARCH_LABEL_PLACEHOLDER: "Butikk eller postnummer",
    IN_STORE: (num: number) => {
        if (num > 1) {
            return `Hent i ${num} butikker.`;
        } else if (num === 1) {
            return "Hent i 1 butikk.";
        } else {
            return "Ingen butikker har varen på lager";
        }
    },
    IN_STORE_EXPANDED: (num: number) => {
        if (num > 1) {
            return `${num} butikker har varen på lager`;
        } else if (num === 1) {
            return "1 butikk har varen på lager";
        } else {
            return "Ingen butikker har varen på lager";
        }
    },
    VIEW_ALL: (num: number) => {
        if (num > 1) {
            return `Se alle ${num} butikker med denne på lager`;
        } else if (num === 1) {
            return "Se 1 butikk med denne på lager";
        } else {
            return "Ingen butikker har varen på lager";
        }
    },
    QUANTITY: (num: number) => {
        if (num > 5) {
            return "5+ på lager";
        } else {
            return `${num} på lager`;
        }
    },
    SHOW_MORE_STORES: (num: number) => `Vis ${num} butikker til`,
    SHOW_LESS_STORES: "Vis færre butikker",
    NEARBY: "I nærheten",
    NO_SUGGESTIONS: "Vi kjenner ikke igjen dette stedet. Vennligst forsøk igjen.",
    GET_HERE: "Hent her",
    OPEN: "Åpen",
    CLOSING: "Stenger",
    CLOSED: "Stengt",
    ERROR: {
        LOCATION_NOT_AVAILABLE:
            "Vi kan dessverre ikke vise tilgjengelige butikker i nærheten av deg. Sjekk at posisjonstjenester er skrudd på, og at nettleseren har tilgang til din posisjon.",
        NO_NEARBY_SHOP: "Det finnes ingen butikker i nærheten med dette produktet tilgjengelig for Klikk & Hent.",
    },
} as const;

export default TEXT;
